import { CreateContactStatusRequest } from './ContactStatus';

export interface ContactStats {
    new: number;
    active: number;
    unassigned: number;
    unread: number;
    unresponded: number;
}

export function buildCreateContactStatus(args: {
    contactId?: number;
    statusId?: number;
    status: string;
}): CreateContactStatusRequest {
    return {
        contactId: args.contactId || undefined,
        statusId: args.statusId || undefined,
        status: args.status,
    };
}
